define(['app/models/cartItem'], function (CartItem) {
    function Product(data, cb, json, silent) {
        var publics = {};
        var privates = {};
        publics.data = {};
        publics.data.all = {};
        publics.data.articles = [];
        publics.data.variants = [];
        publics.data.collection = {};
        publics.data.accessories = [];
        publics.data.selectedArticle = 0;
        publics.data.showAllAlternatives = false;
        publics.data.showAllAccessories = false;
        publics.data.retailerPrice = false;
        publics.data.trackProduct = { newsletter: true, email: '' };
        publics.data.isInFavourites = false;
        publics.data.quantity = 1;
        publics.data.print = false;

        privates.jsonLocation = typeof json !== 'undefined' ? json : window.location.href;
        privates.silent = typeof silent !== 'undefined' ? silent : false;

        publics.init = function () {
            if (partyking) {
                publics.data.retailerPrice = partyking.common.models.shoppingcart.isRetailer() || false;
            }

            if (!_.isObject(data)) {
                privates.loadWithAjax(cb);
            } else {
                publics.data.all = data;

                if (cb) {
                    cb();
                }

                partyking.common.trigger('productPageLoaded', publics.data.all);
            }
        };

        privates.loadWithAjax = function () {
            var jsonLocation = privates.jsonLocation;

            jsonLocation = jsonLocation.replace('.html', '.json');

            partyking.common.progressStart();

            $.getJSON(jsonLocation, function (data) {
                publics.data.all = data;

                publics.data.articles = publics.data.all.articles;
                publics.data.variants = publics.data.all.variants;
                publics.data.accessories = publics.data.all.accessories;
                publics.data.collection = publics.data.all.collection;

                var isArticleSetByArtNr = true;
                if (publics.data.articles.length > 0) {
                    var hash = window.location.hash;
                    var artNr = $.trim(hash.replace('#', ''));

                    if (!publics.selectFromArtNr(artNr)) {
                        isArticleSetByArtNr = false;
                        publics.selectArticle(publics.getFirstByableArticle());
                    }
                }

                partyking.common.progressStop();

                if (cb) {
                    cb(publics);
                }

                if (typeof json === 'undefined') {
                    partyking.common.trigger('productPageLoaded', publics.data.all);
                }
                // if (isArticleSetByArtNr) {
                //     var chk = $('.product-variants input:radio:checked');
                //     chk.trigger('click');
                // }
            });
        };

        publics.selectArticle = function (id) {
            publics.data.selectedArticle = publics.data.articles[id];
        };

        publics.selectFromArtNr = function (artNr) {
            if (!artNr) {
                return false;
            }

            var id = -1;

            $.each(publics.data.articles, function (key, value) {
                var thisArtnr = value.productid + '-' + value.id;
                if (value.is_accessory == 1) return true;
                if (artNr == thisArtnr) {
                    id = key;
                    return false;
                }
            });

            if (id > -1) {
                publics.selectArticle(id);
                return true;
            }

            return false;
        };

        publics.getArtNum = function () {
            return `${publics.data.all.id}-${publics.data.selectedArticle.id}`;
        };

        publics.getQuantity = function () {
            return publics.data.quantity;
        };

        publics.getName = function () {
            return publics.data.all.name;
        };

        publics.getAlternativeName = function () {
            return publics.data.selectedArticle.alternative || '';
        };

        publics.getUrl = function () {
            return publics.data.all.url || '';
        };

        publics.addProductToProductsFromHashedCart = function (product) {
            partyking.common.models.shoppingcart.addProductToProductsFromHashedCart(product);
        };

        publics.addToCart = function (product) {
            let selectedProduct = product;
            if (!selectedProduct) {
                selectedProduct = publics.data.selectedArticle;
            }

            try {
                if (_.isObject(selectedProduct) && privates.isArticleByable(selectedProduct)) {
                    var data = selectedProduct;

                    if (publics.data.print) {
                        data.print = $.extend({}, publics.data.print.getSettings());
                        data.print.thumb = publics.data.print.getThumb();
                    }

                    var item = new CartItem($.extend({}, data));

                    partyking.common.models.shoppingcart.addItem(item, publics.data.quantity || 1);

                    if (privates.silent || partyking.common.helpers.inIframe()) {
                        return true;
                    }

                    partyking.common.models.shoppingcart.showMiniCart = true; // safari need this or it shows the quickcart in the wrong order.

                    _.defer(function () {
                        partyking.common.models.shoppingcart.showMiniCart = false;
                        partyking.common.models.shoppingcart.showMiniCart = true;

                        var cartProductsContainer = $('.minicart .cart-products');
                        setTimeout(function () {
                            cartProductsContainer.prop(
                                'scrollTop',
                                $('[data-artid=' + item.getItemKey() + ']').position().top +
                                    cartProductsContainer.scrollTop()
                            );
                        }, 100);
                    });
                    // privates.showQuickCart();
                    return true;
                }
            } catch (e) {
                partyking.common.log.error('USER ERROR: addToCart', e);
            }

            return false;
        };

        publics.getFirstByableArticle = function () {
            var artId = 0;

            $.each(publics.data.articles, function (id, art) {
                if (privates.isArticleByable(art) && !art.is_accessory) {
                    artId = id;
                    return false;
                }
            });

            return artId;
        };

        publics.isPrint = function () {
            return publics.data.all.product_type === 2;
        };

        privates.isArticleByable = function (art) {
            return (art.status != 0 && art.totalstock > 0) || partyking.common.models.shoppingcart.ignoreStock;
        };

        privates.showQuickCart = function () {
            $('body').toggleClass('no-scroll');
            $('#quickcart').toggleClass('quickcart-closed');
            $('#quickcart-dimmer').toggleClass('hidden');
            $('#beacon-container').toggleClass('hidden');
        };

        privates.addToStringMethodToPrices = function (data) {
            var toStringMethod = function () {
                var sum = Math.round((this.value * (1 + parseFloat(this.vat / 100))) / 100).toFixed(this.precision);
                sum = this.prefix + sum.toString() + this.suffix;
                return sum;
            };

            data.minprice.toString = toStringMethod;

            $.each(data.product_stocks, function (key, value) {
                data.product_stocks[key].price.toString = toStringMethod;
                data.product_stocks[key].saleprice.toString = toStringMethod;
            });

            return data;
        };

        publics.init();

        return publics;
    }

    return Product;
});
